import { useSelector } from 'react-redux';
import { apiCallback } from '@vantiva-sa/homesight_humaui/Services/Common';
import { translator } from '@vantiva-sa/homesight_humaui/Store/configStore';
import { useApiQuery } from './useApiQuery';

const useGetCurrentConditions = ({ useruuid, postalcode, city }) => {
  const trans = useSelector(translator);
  const weatherApi = useSelector((state) => state.apis.weatherApi);

  return useApiQuery(
    ['getCurrentConditions', useruuid],
    () =>
      new Promise((resolve, reject) => {
        weatherApi.getCurrentConditions(
          { useruuid },
          apiCallback({
            translator: trans,
            successCallback: (data) => {
              resolve(data);
            },
            errorCallback: (err) => {
              reject(err);
            },
          })
        );
      }),
    { enabled: !!useruuid && (!!postalcode || !!city) }
  );
};

export default useGetCurrentConditions;
